import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledSelfieboothSectionButton = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 1.25rem;
  flex-flow: column;
`;

export const StyledSelfieboothButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  word-break: break-all;
  background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  color: white;
  padding: 0.75rem;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: ${({ theme }) => pxToRem(theme.button_radius || 0)};
  box-shadow: none;
  transition: 0.2s cubic-bezier(0.25, 0.1, 0.25, 0.1);
  cursor: pointer;
    
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: none;
    font-weight: 700;
    ${({ theme }) => theme.button_font && css`font-family: ${theme.button_font};`};
  }
`;

export const StyledSelfieboothButtonOutlined = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  word-break: break-all;
  background-color: transparent;
  color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  padding: 0.75rem;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: ${({ theme }) => pxToRem(theme.button_radius || 0)};
  box-shadow: none;
  transition: 0.2s cubic-bezier(0.25, 0.1, 0.25, 0.1);
  cursor: pointer;
    
  &:hover {
    background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
    color: white;
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: none;
    font-weight: 700;
    ${({ theme }) => theme.button_font && css`font-family: ${theme.button_font};`};
  }
`;